import { render, staticRenderFns } from "./reverse-relevance-tabs.vue?vue&type=template&id=2d49735c&scoped=true&"
import script from "./reverse-relevance-tabs.vue?vue&type=script&lang=ts&"
export * from "./reverse-relevance-tabs.vue?vue&type=script&lang=ts&"
import style0 from "./reverse-relevance-tabs.vue?vue&type=style&index=0&id=2d49735c&lang=less&scoped=true&"
import style1 from "./reverse-relevance-tabs.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d49735c",
  null
  
)

export default component.exports